import { Component, HostBinding } from '@angular/core';


@Component({
  selector: 'mui-sidebar-page',
  template: `
    <ng-content select="mui-sidebar-page-sidebar,mui-sidebar-page-content"></ng-content>
  `
})
export class MuiSidebarPage {
  @HostBinding('class.mui-sidebar-page')
  private readonly _baseClass = true;
}
